import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormCheckboxField from 'modules/ui/editform/fields/EditFormCheckboxField';
import ValaszEditService from 'app/admin/valasz/service/ValaszEditService';

const config = {
	key: 'valaszEditForm',
	text: 'Válaszok',
	textKey: 'valasz',
	service: ValaszEditService,
	icon: 'person',
	fields: [
		{
			key: 'betujel',
			text: 'Sorszám',
			textKey: 'betujel',
			component: EditFormTextField,
			required: true
		},
        {
			key: 'helyes',
			text: 'Helyes',
			textKey: 'helyes',
			component: EditFormCheckboxField,
			required: true
		},
        {
			key: 'szoveg',
			text: 'Szöveg',
			textKey: 'szoveg',
			component: EditFormTextField,
			required: true
		},
        {
			key: 'magyarazat',
			text: 'Magyarázat',
			textKey: 'magyarazat',
			component: EditFormTextField,
			required: true
		}
	]
};

function ValaszEditForm() {
	return <EditFormPage config={config} />;
}

export default ValaszEditForm;
